// Explicit opt-in presentation contract. Empty values preserve the installed look.
export const MAGNET_VISUAL_STYLES = [
  {
    "value": "",
    "label": "Original"
  },
  {
    "value": "modern",
    "label": "Modern"
  },
  {
    "value": "paper",
    "label": "Paper"
  },
  {
    "value": "bloom",
    "label": "Bloom"
  },
  {
    "value": "signal",
    "label": "Signal"
  },
  {
    "value": "aurora",
    "label": "Aurora"
  },
  {
    "value": "air",
    "label": "Air"
  }
];
export const MAGNET_MOTION_STYLES = [{value:'',label:'Original'},{value:'fade',label:'Fade'},{value:'float',label:'Float'},{value:'spring',label:'Spring'},{value:'still',label:'Still'}];
export const MAGNET_MESSAGE_STYLES = [{value:'',label:'Original'},{value:'soft',label:'Soft fill'},{value:'outline',label:'Outlined'},{value:'raised',label:'Raised'}];
export const MAGNET_VISUAL_PRESETS = [
  {
    "id": "design-modern",
    "name": "Modern",
    "visual_style": "modern",
    "description": "Precise · quiet · modern",
    "font": "system-ui, sans-serif",
    "brand": "#096fc0",
    "light": {
      "surface": "#ffffff",
      "surface_2": "#f0f4f8",
      "msg_bg": "#ffffff",
      "bot_bg": "#f0f4f8",
      "border": "#dbe4ed",
      "bot_border": "#dbe4ed",
      "text": "#162e44",
      "text_sub": "#526779",
      "meta": "#526779",
      "radius": "18px",
      "radius_msg": "16px"
    },
    "dark": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "18px",
      "radius_msg": "16px"
    }
  },
  {
    "id": "design-paper",
    "name": "Paper",
    "visual_style": "paper",
    "description": "Warm paper · confident type",
    "font": "system-ui, sans-serif",
    "brand": "#63523c",
    "light": {
      "surface": "#faf7ef",
      "surface_2": "#eee9de",
      "msg_bg": "#faf7ef",
      "bot_bg": "#eee9de",
      "border": "#d8cdb9",
      "bot_border": "#d8cdb9",
      "text": "#342e27",
      "text_sub": "#6a6053",
      "meta": "#6a6053",
      "radius": "4px",
      "radius_msg": "16px"
    },
    "dark": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "4px",
      "radius_msg": "16px"
    }
  },
  {
    "id": "design-bloom",
    "name": "Bloom",
    "visual_style": "bloom",
    "description": "Soft forms · friendly energy",
    "font": "system-ui, sans-serif",
    "brand": "#7546b8",
    "light": {
      "surface": "#fffafd",
      "surface_2": "#f2eafa",
      "msg_bg": "#fffafd",
      "bot_bg": "#f2eafa",
      "border": "#e2d4ed",
      "bot_border": "#e2d4ed",
      "text": "#382d50",
      "text_sub": "#6d5c80",
      "meta": "#6d5c80",
      "radius": "30px",
      "radius_msg": "16px"
    },
    "dark": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "30px",
      "radius_msg": "16px"
    }
  },
  {
    "id": "design-signal",
    "name": "Signal",
    "visual_style": "signal",
    "description": "Bold edges · graphic contrast",
    "font": "system-ui, sans-serif",
    "brand": "#ffcc57",
    "light": {
      "surface": "#fffdf5",
      "surface_2": "#f7efda",
      "msg_bg": "#fffdf5",
      "bot_bg": "#f7efda",
      "border": "#343931",
      "bot_border": "#343931",
      "text": "#292b28",
      "text_sub": "#64644f",
      "meta": "#64644f",
      "radius": "10px",
      "radius_msg": "16px"
    },
    "dark": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "10px",
      "radius_msg": "16px"
    }
  },
  {
    "id": "design-aurora",
    "name": "Aurora",
    "visual_style": "aurora",
    "description": "Deep color · luminous accents",
    "font": "system-ui, sans-serif",
    "brand": "#a5d9dd",
    "light": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "25px",
      "radius_msg": "16px"
    },
    "dark": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "25px",
      "radius_msg": "16px"
    }
  },
  {
    "id": "design-air",
    "name": "Air",
    "visual_style": "air",
    "description": "Light layers · generous curves",
    "font": "system-ui, sans-serif",
    "brand": "#13738c",
    "light": {
      "surface": "#f8fcff",
      "surface_2": "#e6f3f7",
      "msg_bg": "#f8fcff",
      "bot_bg": "#e6f3f7",
      "border": "#c5dfe7",
      "bot_border": "#c5dfe7",
      "text": "#244451",
      "text_sub": "#53717c",
      "meta": "#53717c",
      "radius": "26px",
      "radius_msg": "16px"
    },
    "dark": {
      "surface": "#192532",
      "surface_2": "#293b4b",
      "msg_bg": "#192532",
      "bot_bg": "#293b4b",
      "border": "#627487",
      "bot_border": "#627487",
      "text": "#f0f5fd",
      "text_sub": "#c3d0dd",
      "meta": "#c3d0dd",
      "radius": "26px",
      "radius_msg": "16px"
    }
  }
];
